import { Product } from "../graphql/__generated__/graphql";
import productQuery from "../graphql/product.graphql";
import app from "../";
import { STOREFRONT_ACCESS_TOKEN, STOREFRONT_API_URL } from "./constants";

/**
 * Get scalar ID https://shopify.dev/docs/api/storefront/2023-01/scalars/ID from product ID integer
 * Example Value: "gid://shopify/Product/10079785100"
 */
export const getProductID = (id: number | string) => {
  if (!id) return null;
  return `gid://shopify/Product/${id}`;
};

export const getProductVariantID = (id: number | string) => {
  if (!id) return null;
  return `gid://shopify/ProductVariant/${id}`;
};

export const getSellingPlanID = (id: number | string) => {
  if (!id) return null;
  return `gid://shopify/SellingPlan/${id}`;
};

export type ProductJSON = {
  data: {
    product: Product;
  };
};

export const fetchProduct = async (id: string): Promise<Product> => {
  const appState = app.getState();
  if (appState.products[id]) {
    return appState.products[id];
  }

  try {
    const response = await fetch(STOREFRONT_API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN,
      },
      body: JSON.stringify({
        query: productQuery,
        variables: { id },
      }),
    });

    const responseJSON: ProductJSON = await response.json();
    return responseJSON.data.product;
  } catch (error) {
    console.error(error);
  }
};

/**
 *
 * @param {Product} product - Product query
 * @param {string} group - SellingPlanGroup name
 * @returns SellingPlans
 */
export const getProductSellingPlans = ({
  product,
  group,
}: {
  product: Product;
  group: string;
}) => {
  const sellingPlanGroup = product.sellingPlanGroups.nodes.find(
    ({ name }) => name === group
  );
  return sellingPlanGroup.sellingPlans;
};

export const getProductSellingPlanAllocation = (
  product: Product,
  sellingPlanId: string
) => {
  return product?.variants?.nodes[0]?.sellingPlanAllocations?.nodes?.find(
    (sellingPlanAllocation) => {
      return sellingPlanAllocation.sellingPlan?.id === sellingPlanId;
    }
  );
};
